// extracted by mini-css-extract-plugin
export default {"fontsizeIcon":"FontsizeIcon_fontsizeIcon__WriSi","fontsizeIcon--active":"FontsizeIcon_fontsizeIcon--active__9u2fb"};